// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_JC2","cls2":"PodcastLibraryCarouselAd-cls2_hFt PodcastLibraryCarouselAd-cls1_JC2"};